export const moduleConfig = {
    entityKey: 'customers',
    titles: {
        singular: 'Customer',
        plural: 'Customers'
    }
}

export const initialSortState = {
    column: 'created',
    direction: 'desc',
};